import React from 'react';
import { FormGroup } from 'react-bootstrap';
import { isBoolean } from 'lodash';

export function CheckBox(props) {
  const { rowIndex, colIndex, onChange, tableIndex, options, CustomAddEditAccess, isProductArchived } = props;

  return (
    <FormGroup className="flex-fill position-relative mb-0">
      <div>
        {options?.map((opt, opIndex) => {
          return (
            <div className="checkbox-label" key={`${opt?.uniqueKey}`}>
              <input
                type="checkbox"
                id={`${opt?.name}_${opIndex}_${tableIndex}_${rowIndex}_${colIndex}`}
                checked={opt?.isChecked || opt?.value || false}
                disabled={(isBoolean(CustomAddEditAccess) ? !CustomAddEditAccess : false) || isProductArchived}
                onChange={(e) => onChange(e.target.checked, rowIndex, colIndex, opt?.name)}
              />
              <label htmlFor={`${opt?.name}_${opIndex}_${tableIndex}_${rowIndex}_${colIndex}`} className="chklabel">
                <span>{opt?.name || opt?.label}</span>
              </label>
            </div>
          );
        })}
      </div>
    </FormGroup>
  );
}
export default CheckBox;
